import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Project, ProjectImage, ProjectSettings, UpdateProjectImageRequest} from "../../../../core/models";
import {SelectItem} from "primeng/api";
import {PlayerService, ProjectImageService} from "../../../../core/services";
import {AppComponent} from "../../../../app.component";
import {EventService, FileHelperService} from "../../../../core";

@Component({
  selector: 'app-project-image',
  templateUrl: './project-image.component.html'
})
export class ProjectImageComponent implements OnInit {

  @Input() editable: boolean = false;
  @Input() icon: boolean = false;
  @Input() project: Project;

  showFileUload: boolean = false;
  projectImage: ProjectImage = null;

  constructor(
    private projectImageService: ProjectImageService,
    private fileHelperService: FileHelperService,
    private eventService: EventService,
    public app: AppComponent
  ) {

  }

  ngOnInit() {
    this.getProjectImage();
  }

  onClick() {
    this.showFileUload = ! this.showFileUload;
  }

  getProjectImage() {
    this.projectImageService.get(this.project.id)
      .subscribe(
        (data) => {
          this.projectImage = data;
        },
        (error) => {
          this.projectImage = {};
        }
      );
  }

  storeFile(event: any, fileUpload: any) {
    const file = event.files[0];
    if (!file.type.startsWith('image/')) {
      this.eventService.warn('invalid content, please uplaod an image');
      return;
    }
    this.fileHelperService.fileToDataUrl(file, (data) => {
      this.projectImage.data = data;
      const request = new UpdateProjectImageRequest(data);
      this.projectImageService.update(request, this.project.id)
        .subscribe(
          (data) => {
            this.projectImage = data;
            fileUpload.clear();
          },
          (error) => {
            fileUpload.clear();
          }
        );
    });
  }

}

